import script from "./DeviceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&setup=true&lang=js"

import "./DeviceDetail.vue?vue&type=style&index=0&id=02772868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02772868"]])

export default __exports__